<template>
  <div class="plan-icon ml-1 mr-1 w-6">
    <img v-bind:src="getIcon"/>
  </div>
</template>

<script>
import TTrain from "../../assets/images/icon-plan-station.svg"
import PinPlace from "../../assets/images/icon-destination.svg"

// TODO: 設定に移す
const checkInCategory = "$t('tour_check_in_category')";

export default {
  props: {
    place: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    getIcon: function () {
      if (this.place.type == "station") {
        return TTrain;
      } else {
        if (this.place.lock) {
          return PinPlace;
        } else {
          if (this.place.category == checkInCategory) {
            return PinPlace;
          } else {
            return PinPlace;
          }
        }
      }
    }
  }
}
</script>
